import { accountRoutes } from './modules/account';
import { masterDataRoutes } from './modules/masterData';
import { pz05Routes } from './modules/pz05';
import { pz04Routes } from './modules/pz04';
import { operationsRoutes } from './modules/operations';
import { mailingRoutes } from './modules/mailing';
import { warehouseRoutes } from './modules/warehouse';

export const appRoutes = [
  ...accountRoutes,
  ...masterDataRoutes,
  ...pz05Routes,
  ...pz04Routes,
  ...operationsRoutes,
  ...mailingRoutes,
  ...warehouseRoutes,
];
